import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import BetkoShopLayout from './BetkoShopLayout'
import classes from './BetkoShopUslovi.module.css'
import { betkoShopUsloviData } from './BetkoShopUsloviData'
import { Button, Form, Input, message, Modal } from 'antd'
import { CloseOutlined } from '@ant-design/icons';
import axios from '../../config/axios'
import LoginModalNovo from '../../components/LoginModalNovo'
import AuthContext from '../../context/AuthProvider'
import useRefreshToken from '../../hooks/useRefreshToken'
import { betkoErrorPopup, betkoInfoPopup, betkoSuccessPopup } from '../../utils/notifications'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

const BetkoShopUslovi = () => {
  const { auth } = useContext(AuthContext)
  const [isSellerModalVisible, setIsSellerModalVisible] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [searchParams] = useSearchParams()
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const refresh = useRefreshToken()
  const menu = searchParams.get('menu')
  const title = searchParams.get('title')
  const [form] = Form.useForm()
  const navigate = useNavigate()


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleRequestShop = async () => {
    try {
      const values = await form.validateFields()
      const response = await axios.post(
        `${SERVER_URL}/user/request-shop/${auth._id}`,
        { ...values }
      )
      betkoSuccessPopup(response?.data || 'Zahtev je uspešno poslat!')
      setIsSellerModalVisible(false)
      refresh()
    } catch (error) {
      betkoErrorPopup(
        error?.response?.data?.message ||
          'Greška, pokušajte kasnije ili nas kontaktirajte!'
      )
    }
  }
  return (
    <BetkoShopLayout>
      <LoginModalNovo
        isOpen={isLoginModalOpen}
        setIsOpen={setIsLoginModalOpen}
        title='Da bi ste postali prodavac morate se ulogovati!'
        
      />
      <Modal
        open={isSellerModalVisible}
        onOk={handleRequestShop}
        onCancel={() => {
          setIsSellerModalVisible(false)
          form.resetFields()
        }}
        closable={true}
        closeIcon={<CloseOutlined style={{ color: 'white', fontSize: '18px' }} />}
        footer={[
          <Button
            key='back'
            onClick={() => {
              setIsSellerModalVisible(false)
              form.resetFields()
            }}
          >
            Otkaži
          </Button>,
          <Button key='submit' type='primary' onClick={handleRequestShop} className={classes.submitButton}>
            Potvrdi
          </Button>,
        ]}
      >
        <Form form={form} layout='vertical' className={classes.cf}>
          <h3>Unestite podatke o kompaniji</h3>
          <Form.Item
            name='companyName'
            label='Naziv kompanije'
            rules={[
              { required: true, message: 'Molimo unesite naziv kompanije!' },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='companyAddress'
            label='Adresa kompanije'
            rules={[
              { required: true, message: 'Molimo unesite adresu kompanije!' },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='companyPlace'
            label='Mesto kompanije'
            rules={[
              { required: true, message: 'Molimo unesite mesto kompanije!' },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='companyPIB'
            label='PIB'
            rules={[
              { required: true, message: 'Molimo unesite PIB!' },
              { len: 9, message: 'PIB mora imati tačno 9 cifara!' },
              {
                pattern: /^[0-9]+$/,
                message: 'PIB može sadržavati samo cifre!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='companyMIB'
            label='Matični broj'
            rules={[
              { required: true, message: 'Molimo unesite Matični broj!' },
              { len: 8, message: 'Matični broj mora imati tačno 8 cifara!' },
              {
                pattern: /^[0-9]+$/,
                message: 'Matični broj može sadržavati samo cifre!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
      <div className={`${classes.pageContainer} ${classes[menu]}`}>
        <div className={classes.menuTitle}>
        <h2>{typeof menu === 'string' ? menu.replaceAll('-', ' ') : ''}</h2>
        </div>
        <div className={classes.navBtns}>
          <button
            onClick={() =>
              navigate(
                `/betko_shop/uslovi?menu=${menu}&title=uslovi-za-korisnike`
              )
            }
          >
            USLOVI ZA KORISNIKE
          </button>
          <button
            onClick={() =>
              navigate(`/betko_shop/uslovi?menu=${menu}&title=saznaj-vise`)
            }
          >
            SAZNAJ VIŠE
          </button>
          <button
            onClick={() =>
              navigate(
                `/betko_shop/uslovi?menu=${menu}&title=uslovi-za-ponudjace`
              )
            }
          >
            USLOVI ZA PONUĐAČE
          </button>
        </div>
        <div className={`${classes.navBtns} ${classes.becomeSellerBtn}`}>
          {auth.accessAdminShop === 'requested' ? (
            <button>ČEKA SE ODOBRENJE</button>
          ) : auth.accessAdminShop === 'approved' ? (
            <button
              onClick={() => {
                if (isMobile) {
                  betkoInfoPopup('Morate biti na desktop uređaju da biste pristupili admin panelu!');
                } else {
                  navigate('/betko-shop-admin/home');
                }
              }}
            >
              KLIKOM NA OVO POLJE (ISKLJUČIVO NA RAČUNARU, NE I NA MOBILNOM
              TELEFONU) MOŽETE PRISTUPITI VAŠEM ADMINISTRATORSKOM PROFILU.
            </button>
          ) : (
            <button
              onClick={() => {
                console.log('auth:', auth);
                if (auth?._id) {
                  setIsSellerModalVisible(true);
                } else {
                  console.log("Korisnik nije ulogovan, otvaram login modal");
                  setIsLoginModalOpen(true);
                }
              }}
            >
              KLIKNI I POSTANI{' '}
              {menu === 'licitacije'
                ? 'LICITATOR'
                : menu === 'shop'
                ? 'PRODAVAC'
                : 'ORGANIZATOR PUTA'}
            </button>
          )}
        </div>
        <h3>
          {title
            ? String(title)
                .replaceAll('-', ' ')
                .replaceAll('vise', 'više')
                .replaceAll('ponudjace', 'ponuđače')
            : ''}
        </h3>
        <div className={classes.textWrapper}>
          {betkoShopUsloviData[menu][title].split('\n').map((line, idx) => (
            <p key={idx}>{line}</p>
          ))}{' '}
        </div>
      </div>
    </BetkoShopLayout>
  )
}

export default BetkoShopUslovi
